import { PUBLIC_HTTP as http } from '../http-common';

export const signUp = async (body: any) => {
  const response = await http.post('/api/v4/users', body);
  return response.data;
};

export const checkSignUpStatus = async (data: any) => {
  const response = await http.get(data?.url, {
    headers: { 'X-JOB-AUTHORIZATION': data?.token },
  });
  return response;
};
